export default {"src":"/_next/static/media/logo-full.eba8f1b6.svg","height":104,"width":316,"blurWidth":0,"blurHeight":0};